import { Show, SimpleShowLayout, TextField, DateField, ReferenceField, FunctionField } from "react-admin";
import { Box } from "@mui/material";
import { ResourceName } from "@/types";
import { getPartnerAwareApiUrl } from "@/providers/dataProvider/dataProvider";
import { toAbsoluteImageUrls } from "./imageUrls";
import { sanitizeArticleHtml } from "@/utils/sanitizeHtml";

interface HelpArticleRecord {
  body_html?: string;
}

/** Read-only article view (Feature 4317 / N3). Renders the sanitized HTML body. */
export const HelpArticleShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="title" />
      <TextField source="slug" />
      <ReferenceField
        source="category_id"
        reference={ResourceName.HELP_CATEGORIES}
        label="Category"
        link={false}
        emptyText="—"
      >
        <TextField source="name" />
      </ReferenceField>
      <TextField source="status" />
      <DateField source="published_datetime" label="Published" emptyText="—" showTime />
      <DateField source="modified_datetime" label="Updated" emptyText="—" showTime />
      <FunctionField
        label="Body"
        render={(record: HelpArticleRecord) => (
          <Box
            sx={{ "& img": { maxWidth: "100%" } }}
            dangerouslySetInnerHTML={{
              __html: sanitizeArticleHtml(toAbsoluteImageUrls(record?.body_html, getPartnerAwareApiUrl())),
            }}
          />
        )}
      />
    </SimpleShowLayout>
  </Show>
);
